export default {
  state: {
    permissions: []
  },
  getters: {
    getPermissions(state){
      return state.permissions;
    },
  },
  mutations: {
    setPermissions(state, permissions){
      state.permissions = permissions;
    },
  },
  actions: {
    setPermissions(context, permissions){
      context.commit('setPermissions', permissions);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/permission.js